export const defaultConfig = {
  dsn: 'https://cbd3f90018974e2187a7d6e0c261cd72@sentry.io/1454233',
  environment: undefined,
  layer: 'view',
  section: 'lookiero-app',
  ignoredErrors: [],
  beforeSend: event => event,
};
